import axios from 'axios';
import {backendHost} from '../../config';

export const postBonusCode = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/bonus-code`, params);
};